<template>
	<inertia-head title="Sales Page" />

	<div class="content">
		<div class="row">
			<div class="col-sm-12 col-md-12 col-lg-12">
				
			</div>
		</div>
	</div>
</template>

<script>
	import GuestLayout from '../Layouts/GuestLayout';

	export default{
		layout: GuestLayout,
		props:{

		},
		setup(props){

		}
	}
</script>